// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__30HVt","inner":"Form_inner__2tPA8","range":"Form_range__206Kv","name":"Form_name__3MQQe","actions":"Form_actions__3V3U1"};